import { all } from 'redux-saga/effects';
import authSaga from './authSagas';
import schoolSaga from './schoolSagas';
import commonSaga from './commonSagas';
import moduleSaga from './moduleSaga';
import classSaga from './classesSagas';
import gradeSaga from './gradeSagas';
import studentPracticeSaga from './studentPracticeSaga';
import roleSaga from './roleSagas';
import groupPermissionsSaga from './groupPermissionsSagas';
import accountSagas from './accountSagas';
import examSaga from './studentExamSagas';
import studentDashboardSaga from './studentDashboardSagas';
import studentManagementSaga from './studentManagementSagas';
import adminDashboardSaga from './adminDashboardSagas';
import adminReportingSaga from './reportingSaga';
import calendarSaga from './calendarSaga';
import meetingSaga from './meetingSaga';
import learningMaterialSaga from './learningMaterialSaga';
import scoringSaga from './scoringSagas';
import zoomSaga from './zoomSagas';
import aiConversationSaga from './aiConversationSagas';
import teacherDashboardSaga from './teacherDashboardSagas';
import partnerSaga from './partnerSagas';
import taskJobSagas from './taskJobSagas';
import permissionSaga from './permissionSagas';
export default function* rootSaga() {
    yield all([
        authSaga(),
        schoolSaga(),
        commonSaga(),
        moduleSaga(),
        classSaga(),
        gradeSaga(),
        studentPracticeSaga(),
        roleSaga(),
        groupPermissionsSaga(),
        accountSagas(),
        examSaga(),
        studentDashboardSaga(),
        studentManagementSaga(),
        adminDashboardSaga(),
        adminReportingSaga(),
        calendarSaga(),
        meetingSaga(),
        learningMaterialSaga(),
        scoringSaga(),
        zoomSaga(),
        aiConversationSaga(),
        teacherDashboardSaga(),
        partnerSaga(),
        taskJobSagas(),
        permissionSaga(),
    ]);
}
